// extracted by mini-css-extract-plugin
export var dropdown = "_to-0";
export var imageWrapper = "_to-3";
export var itemNameContainer = "_to-1";
export var productImage = "_to-2";
export var spinnerWrapper = "_to-4";